import React from 'react'
import UserProviderStats from '../components/stat/UserProviderStat.jsx'
import DeviceStats from '../components/stat/DeviceStat.jsx'
import SubscriptionStat from '../components/stat/SubscriptionStat.jsx'

const Insights = () => {
  return (
    <div>
      <DeviceStats/>
      <UserProviderStats/>
      <SubscriptionStat/>
    </div>
  )
}

export default Insights
